import { Button } from "@/src/components/buttons";
import { Card, CompartmentCard } from "@/src/components/cards";
import { openDrawer } from "@/src/components/dialogs";
import { FetchableList } from "@/src/components/fetchableLists";
import { Input } from "@/src/components/universalInput";
import { Patient, Story, User } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import {
  formatDate,
  getUserId,
  getUserShortName,
  uid,
} from "@/src/utils/utils";
import moment from "moment";
import { useState } from "react";
import { UserAvatar } from "../admin/users/userAvatar";
import { HtmlDiv } from "../documents/htmlDiv";
import { openDiscussionDrawer } from "../messagerie/messageriePage";
import { getStandardConfidentiality } from "../patients/confidentialitiesHook";

function StoryCompartment({
  patient,
  parentId,
}: {
  patient: Patient;
  parentId: string;
}) {
  let [searchKey, setSearchKey] = useState("");
  const [reload, setReload] = useState(0);

  return (
    <CompartmentCard
      title={"Histoire de la maladie"}
      onClick={async () => {
        let item: Story = {
          patient: patient,
          creator: getUserId(),
          type: "story",
          content: null,
          reference: null,
          confidentiality: getStandardConfidentiality(patient),
          readBy: [getUserId()],
        };

        openDrawer({
          title: "Ajouter une histoire de la maladie",
          content: (
            <StoryForm
              current={item}
              onChange={(newItem) => {
                item = newItem;
              }}
            />
          ),
          onConfirm: async () => {
            await apiFetch("stories", "addOne", { story: item });
            setReload((prev) => prev + 1);
          },
        });
      }}
    >
      <FetchableList
        queryKey={["StoryCompartment", searchKey, patient.id, reload]}
        queryFn={async () => {
          let last = await apiFetch("stories", "loadLast", {
            patientId: patient.id,
            parentId: null,
          });
          if (!last) return [];
          return [last];
        }}
        emptyChild={<div className="gray center p10">Aucun élément trouvé</div>}
      >
        {(data) => (
          <div className="grid c1 gap10">
            {data?.map((story, index) => {
              return (
                <Card
                  key={uid()}
                  animationIndex={index}
                  color="simple"
                  leading={<></>}
                  onClick={async () => {
                    await openDrawer({
                      title: "Historique de l'histoire de la maladie",
                      content: (
                        <StoryForm
                          current={story}
                          onChange={(newItem) => {
                            story = newItem;
                          }}
                        />
                      ),
                      onConfirm: async () => {
                        story.creator = getUserId();
                        await apiFetch("stories", "addOne", { story });
                        setReload((prev) => prev + 1);
                      },
                    });
                  }}
                >
                  <div className="c1 gap10">
                    <HtmlDiv>{story.conclusion}</HtmlDiv>
                    <div className="gray">
                      {formatDate(story?._date, "LL HH:mm")}
                    </div>
                    <UserMiniCard
                      item={parentId}
                      user={story.creator}
                    ></UserMiniCard>
                  </div>
                </Card>
              );
            })}
            <Button
              type={"tertiary"}
              onClick={() => {
                openDrawer({
                  title: "Historique de l'histoire de la maladie",
                  content: <StoriesList patient={patient} />,
                  onClose: () => {
                    setReload((prev) => prev + 1);
                  },
                  footer: <div></div>,
                });
              }}
            >
              Voir plus
            </Button>
          </div>
        )}
      </FetchableList>
    </CompartmentCard>
  );
}

export function UserMiniCard({
  item,
  user,
  onClick,
}: {
  item: any;
  user: User | null | undefined;
  onClick?: () => void;
}) {
  if (!user) return null;
  return (
    <div>
      <div
        className="userMiniCard "
        onClick={async () => {
          if (onClick) return await onClick();
          console.log("thrhrhrhrhr item", item);
          await openDiscussionDrawer({
            interlocutor: user,
            attachedItem: item,
          });
        }}
      >
        <div className="left">
          <UserAvatar user={user} size={20}></UserAvatar>
        </div>
        <div className="gray">{getUserShortName(user)}</div>
      </div>
    </div>
  );
}

function StoriesList({ patient }: { patient: Patient }) {
  let [searchKey, setSearchKey] = useState("");
  const [reload, setReload] = useState(0);

  return (
    <FetchableList
      queryKey={["StoriesList", searchKey, patient.id, reload]}
      queryFn={() =>
        apiFetch("stories", "loadMany", {
          patientId: patient.id,
          parentId: null,
        })
      }
    >
      {(data) => (
        <div className="grid c1 gap10">
          {data?.map((story, index) => {
            return (
              <Card
                key={uid()}
                animationIndex={index}
                color="blue"
                title={getUserShortName(story?.creator)}
              >
                <div>{story.conclusion}</div>
                <div className="gray">
                  {moment(story?._date).format("LL HH:mm")}
                </div>
              </Card>
            );
          })}
        </div>
      )}
    </FetchableList>
  );
}

function StoryForm({
  current,
  onChange,
}: {
  current?: Story;
  onChange: (newValue: Story) => void;
}) {
  let [data, setData] = useState(current || ({} as Story));
  function setNewValue(newValue: Story) {
    setData(newValue);
    onChange(newValue);
  }

  return (
    <div className="grid c1 gap10">
      <Input
        name="text"
        shouldFocus={true}
        value={data.conclusion}
        type="textarea"
        rows={10}
        placeholder="Texte libre..."
        onChange={(newValue) => {
          setNewValue({ ...data, conclusion: newValue });
        }}
      />
    </div>
  );
}

export { StoryCompartment };
